module.exports = __webpack_public_path__ + "static/media/prop-11.316c2ed6.webp";